
import { connect } from 'react-redux';
import { CurrentOfferings } from "./current-offerings";
import {setOfferings} from "./actions";
import {navigatePath} from "../../nav/actions";
import {addUserSecurityItems} from "../../superadmin/security-purchase-reducer";

const mapDispatchToProps = dispatch => {
  return {
    navigatePath: (path, args) => dispatch(navigatePath(path, args)),
    addUserSecurityItems: (username, items) => dispatch(addUserSecurityItems(username, items)),
    setOfferings: (offerings) => dispatch(setOfferings(offerings)),
  };
};

const mapStateToProps = state => {
  return {
    cdOffering: state.cdOffering,
    client: state.client,
    app: state.app,
    user: state.user,
    userPayments: state.userPayments,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CurrentOfferings);
